import script from "./PopoverMenuItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopoverMenuItem.vue?vue&type=script&lang=ts&setup=true"

import "./PopoverMenuItem.vue?vue&type=style&index=0&id=3aa40a75&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aa40a75"]])

export default __exports__